import React from 'react';
import moment from 'moment';

import SkuInput from './sku';

interface Props {
    lastModified?: Date;
    productName?: string;
    firstSurfaceHeight: number;
    firstSurfaceWidth: number;
    retrievingSurfaces?: boolean;
    isReady: boolean;
}

const Product: React.FC<Props> = ({
    productName,
    lastModified,
    firstSurfaceWidth,
    firstSurfaceHeight,
    retrievingSurfaces,
    isReady,
}) => {
    return (
        <div className='product-data'>
            <p className='choose-sku__title'>Type in a product SKU:</p>
            {/* `required` is not provided by the SkuInput container's mapStateToProps/mapDispatchToProps,
                so it must be passed here as an ownProp; `false` matches the previous untyped behavior
                where no value was passed at all. */}
            <SkuInput required={false} />
            {productName && isReady && (
                <div>
                    <div className='link__data'>
                        <div className='link__data-title'>Name:</div>
                        <div className='link__data-value'>{productName}</div>
                    </div>
                    <div className='link__data'>
                        <div className='link__data-title'>Last Modified:</div>
                        <div className='link__data-value'>{moment(lastModified).fromNow()}</div>
                    </div>
                    <div className='link__data'>
                        <div className='link__data-title'>Surface Dimensions:</div>
                        {!retrievingSurfaces ? (
                            <div className='link__data-value'>
                                Width: {`${firstSurfaceWidth} cm `}
                                <br />
                                Height: {`${firstSurfaceHeight} cm `}
                            </div>
                        ) : (
                            <div className='link__data-value'>Loading surface data...</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default React.memo(Product);
